import { Helmet } from 'react-helmet-async';

// Google Search Console Verification Component
export const GoogleSearchConsole = () => {
  const GSC_VERIFICATION = process.env.REACT_APP_GSC_VERIFICATION;

  if (!GSC_VERIFICATION || GSC_VERIFICATION === 'YOUR_GSC_VERIFICATION_CODE') {
    return null;
  }

  return (
    <Helmet>
      <meta name="google-site-verification" content={GSC_VERIFICATION} />
    </Helmet>
  );
};
